<div class="flex flex-col p-8 bg-card shadow rounded overflow-hidden mr-4">
  <p class="text-lg font-medium">{{ title }}</p>
  <mat-divider class="mt-8 mb-10"></mat-divider>
  <div class="flex flex-col gt-sm:flex-row">
    <form [formGroup]="dropdownForm">
      <div class="add-label" [formGroupName]="'newOption'">
        <div class="label">
          <mat-form-field>
            <mat-label>New Value</mat-label>
            <input matInput [formControlName]="'name'" />
            <button
              mat-icon-button
              matSuffix
              [disabled]="!dropdownForm.get('newOption').valid || !dropdownForm.get('newOption').dirty"
              (click)="addOption()"
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="labels" [formArrayName]="'options'" cdkDropList (cdkDropListDropped)="drop($event)">
        <div
          class="label flex flex-auto"
          *ngFor="let option of dropdownForm.get('options')['controls']; index as i"
          cdkDrag
        >
          <div></div>
          <div class="drag-handle dropdown-drag" cdkDragHandle [matTooltip]="'ID: ' + option.get('id').value">
            <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
          </div>
          <mat-form-field>
            <mat-label></mat-label>
            <input matInput [formControl]="option.get('name')" />
            <button mat-icon-button matSuffix (click)="showHideOption(option)" *ngIf="option.get('hidden').value">
              <mat-icon [svgIcon]="'visibility_off'"></mat-icon>
            </button>
            <button mat-icon-button matSuffix (click)="showHideOption(option)" *ngIf="!option.get('hidden').value">
              <mat-icon [svgIcon]="'visibility'"></mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field class="flex w-1/4">
            <mat-label></mat-label>
            <mat-select [formControl]="option.get('pipeline_ids')" multiple>
              <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
                {{ pipeline.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex w-1/4" *ngIf="showRequiredFields">
            <mat-label></mat-label>
            <mat-select [formControl]="option.get('required_fields')" multiple>
              <mat-option *ngFor="let field of fieldDefs" [value]="field.name">
                {{ field.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="showColor" class="w-1/6">
            <div style="position: absolute; left: 20px">
              <mat-icon
                [ngClass]="isAccountColor(option) ? '' : 'text-' + option.get('color').value + '-500'"
                [ngStyle]="isAccountColor(option) ? { color: getAccountColor(option) } : {}"
                [svgIcon]="'color_lens'"
              ></mat-icon>
            </div>
            <mat-label></mat-label>
            <mat-select
              class="calendar-color-selector"
              [(value)]="option.get('color').value"
              [panelClass]="'calendar-sidebar-calendar-edit-panel-color-select-panel'"
              [disableOptionCentering]="true"
              [formControl]="option.get('color')"
              matPrefix
            >
              <div class="color-box-title">Default Colors</div>
              <div class="color-box-container">
                <mat-option *ngFor="let color of calendarColors" [value]="color" #matOption="matOption">
                  <mat-icon [ngClass]="color + '-500'" *ngIf="matOption.selected" [svgIcon]="'check'"></mat-icon>
                  <span class="color-box" [ngClass]="color + '-500'"></span>
                </mat-option>
              </div>
              <div class="color-box-title">Account Colors</div>
              <div class="color-box-container">
                <mat-option *ngFor="let color of accountColors" [value]="'account:' + color.id" #matOption="matOption">
                  <mat-icon *ngIf="option.get('color').value === 'account:' + color.id" [svgIcon]="'check'"></mat-icon>
                  <span class="color-box" [ngStyle]="{ 'background-color': color.hex_value }"></span>
                </mat-option>
                <div #addButton class="add-container plus-icon" (click)="openColorPicker(colorInput)">
                  <mat-icon>add</mat-icon>
                </div>
              </div>
              <input #colorInput class="h-0" type="color" (change)="onColorChange($event, option)" />
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
